<template>
  <footer class="footer">
    <div class="footer-wrap">
      <div class="container">
        <div class="footer-cols">
          <div class="header-logos">
            <span>
              <img src="@/assets/img/ui/logo-dark.svg" alt="">
            </span>
          </div>
          <div class="footer-link-group">
            <a :href="rulesUrl" @click="$emit('rules-click')" target="_blank">
              Правила акции
            </a>
            <a :href="policyUrl" @click="$emit('rules-click')" target="_blank">
              Пользовательское соглашение
            </a>
          </div>
        </div>
        <div class="footer-text">
          Общий срок проведения Акции: с 00 часов 00 минут 00 секунд 28 апреля 2026 года – по 23 часа 59 минут 59 секунд 22  июля 2026 года (включительно). Сроки совершения покупок Товара и регистрации чеков на сайте: с 00 часов 00 минут 00 секунд 28 апреля 2026 года – по 23 часа 59 минут 59 секунд 22 июня 2026 года (включительно). Сроки определения Победителей Акции: с 00 часов 00 минут 00 секунд 28 апреля 2026 года – по 23 часа 59 минут 59 секунд 26 июня 2026 года (включительно). Сроки вручения и передачи всех призов Призового фонда Акции: с 28 апреля 2026 года по 22 июля 2026 года (включительно).
          <br><br>Erid: 2SDnjd5NEd2, ООО «Мистраль Трейдинг», ИНН 7729569817
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    rulesUrl: {
      type: String,
      required: true,
    },
    policyUrl: {
      type: String,
      required: true,
    },
  },
  emits: ['rules-click', 'open-question'],
};
</script>
